import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

export function mapContactMessageFromApi(d) {
  return {
    id: d.id,
    senderName: d.senderName ?? '',
    senderEmail: d.senderEmail ?? '',
    senderPhone: d.senderPhone ?? '',
    subject: d.subject ?? '',
    message: d.message ?? '',
    createdAtUtc: d.createdAtUtc ?? '',
    isRead: Boolean(d.isRead),
  };
}

export async function fetchSuperAdminContactMessages() {
  const res = await fetch(`${API_BASE}/api/superadmin/contact-messages`, { headers: { Accept: 'application/json', ...authHeaders() } });
  const data = await res.json().catch(() => ([]));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل الرسائل'));
  return (Array.isArray(data) ? data : []).map(mapContactMessageFromApi);
}

export async function updateSuperAdminContactMessageRead(id, isRead) {
  const res = await fetch(`${API_BASE}/api/superadmin/contact-messages/${id}/read`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify({ isRead: Boolean(isRead) }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحديث حالة الرسالة'));
  return mapContactMessageFromApi(data);
}
